import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, AlertCircle } from 'lucide-react';
import { exchangeFacetCode } from '../services/auth';

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [exchangeError, setExchangeError] = useState('');

  // 参数类错误在渲染期派生，避免在 effect 中同步 setState
  const errorParam = searchParams.get('error');
  const hasRequiredParams = Boolean(searchParams.get('code') && searchParams.get('state'));
  const paramError = errorParam
    ? `Facet 登录失败: ${errorParam}`
    : hasRequiredParams
      ? ''
      : '登录回调缺少必要参数';
  const error = paramError || exchangeError;

  useEffect(() => {
    if (paramError) return;
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    if (!code || !state) return;

    exchangeFacetCode(code, state)
      .then(() => {
        window.location.href = '/';
      })
      .catch((err) => {
        const e = err as { response?: { data?: { detail?: unknown } }; message?: unknown };
        const detail = e.response?.data?.detail;
        setExchangeError(
          typeof detail === 'string' ? detail : typeof e.message === 'string' ? e.message : '登录失败'
        );
      });
  }, [searchParams, navigate, paramError]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--gradient-dark)',
        padding: '24px',
      }}
    >
      <div
        className="glass-card neon-border"
        style={{
          width: '100%',
          maxWidth: '420px',
          padding: '40px',
          textAlign: 'center',
        }}
      >
        {error ? (
          <>
            <AlertCircle size={48} style={{ color: 'var(--danger)', marginBottom: '16px' }} />
            <h2 style={{ margin: '0 0 12px', fontSize: '20px' }}>登录失败</h2>
            <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>{error}</p>
            <button className="primary" onClick={() => navigate('/login')} style={{ marginTop: '24px' }}>
              返回登录页
            </button>
          </>
        ) : (
          <>
            <Loader2 size={48} className="spin" style={{ color: 'var(--neon-blue)', marginBottom: '16px' }} />
            <h2 style={{ margin: '0 0 12px', fontSize: '20px' }}>正在完成登录</h2>
            <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>请稍候，正在与 Facet 统一身份中心交换凭证...</p>
          </>
        )}
      </div>
    </div>
  );
}
